var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filterBackend || _vm.options.length > _vm.enableAutocompleteSize)?_c('div',{staticClass:"autocomplete"},[_c('input',{ref:"input",attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onChange}}),_c('Icon',{staticClass:"autocomplete-icon",attrs:{"name":"Search"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }